<template>
  <v-container v-if="!noncompetitionHide">
    <AppLoadingPage v-if="$apollo.queries.documents.loading" />
    <template v-else>
      <EventDocumentsTemplate
        v-model:documents="documents"
        :event-id="event.id"
        :allowed-mutations="event.allowedMutations"
      >
        <template #label>
          <slot name="label" />
        </template>
      </EventDocumentsTemplate>
    </template>
  </v-container>
</template>

<script>
import gql from "fraql";
import AppLoadingPage from "@/components/elements/AppLoadingPage.vue";
import EventDocumentsTemplate from "./EventDocumentsTemplate.vue";
export default {
  name: "EventDocuments",
  components: {
    AppLoadingPage,
    EventDocumentsTemplate
  },
  inject: {
    isNoncompetition: {
      default: false
    }
  },
  props: {
    event: { type: Object, required: true }
  },
  data() {
    return {
      documents: []
    };
  },
  computed: {
    noncompetitionHide() {
      if (!this.isNoncompetition) return false;
      return (
        this.documents.length == 0 &&
        !this.$allowedMutation(this.event.allowedMutations, "eventDocumentAdd")
      );
    }
  },
  fragments: {
    documentsListing: gql`
      fragment _ on Event {
        documentsListing {
          ${EventDocumentsTemplate.fragments.eventDocumentFields}
        }
      }
    `
  },
  apollo: {
    documents: {
      query: gql`
        query event($id: ID) {
          event(id: $id) {
            id
            documentsListing {
              ${EventDocumentsTemplate.fragments.eventDocumentFields}
            }
          }
        }
      `,
      variables() {
        return {
          id: this.event.id
        };
      },
      update({ event }) {
        return event.documentsListing;
      },
      fetchPolicy: "cache-first"
    }
  }
};
</script>
